var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/banner/banner.tsx";
import classNames from 'classnames';
import React from 'react';
/** Displays a sticky full-width banner at the bottom of the screen. */
const Banner = ({
  theme,
  children,
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "banner",
    className: classNames('fixed bottom-0 left-0 right-0 py-8 z-50', {
      'backdrop-blur bg-primary-900/80': theme === 'frosted',
      'bg-white dark:bg-slate-800 text-black dark:text-white shadow-3xl dark:shadow-inset': theme === 'opaque'
    }, className),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "max-w-4xl mx-auto px-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 7
    }
  }, children));
};
export default Banner;